<template>
  <div class="wrapper">
    <div class="content">
      <template v-if="listData.length > 0">
        <div
          v-for="(item, index) in listData"
          :key="index"
          @click="itemClick(item)"
        >
          <slot name="itemRow" :item="item"></slot>
        </div>
        <!-- 统一维护列表加载完文案 -->
        <div v-if="loadEnd">
          <p class="laodEndText">{{ loadEndText }}</p>
        </div>
      </template>
      <!-- 统一维护没有数据页面 -->
      <template v-else>
        <div class="emptyDataImg">
          <img width="70%" :src="emptyImg" />
          <p>暂无数据</p>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
// 该组件主要用于列表的滚动加载，统一维护空数据样式，数据加载完底部提示，滚动加载操作统一
import BetterScroll from "better-scroll";

export default {
  props: {
    loadEnd: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    listData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    loadEndText: {
      type: String,
      default: () => {
        return "没有更多内容啦~";
      }
    },
    emptyImg: {
      type: String,
      default: () => {
        return require("./empty.png");
      }
    }
  },
  data() {
    return {
      bs: null
      // loadEndText: "没有更多内容啦~",
      // emptyImg: require("./empty.png")
    };
  },
  watch: {
    listData: {
      handler() {
        if (this.bs) {
          setTimeout(() => {
            this.bs.refresh();
          }, 100);
        }
      },
      immediate: true,
      deep: true
    },
    loadEnd() {
      setTimeout(() => {
        this.bs.refresh();
      }, 100);
    }
  },
  components: {},
  async mounted() {
    setTimeout(() => {
      this.bs = new BetterScroll(".wrapper", {
        scrollY: true,
        pullUpLoad: true,
        click: true,
        mouseWheel: true,
        bounce: false
      });
      // 使用scroll事件，可兼容移动端和PC端，父组件使用时，考虑组件之间传递数据的异步操作，可能会多次出发该事件，需要做好处理
      // 通常请求是，记录loading:true,请求结束后loading:false，只有在loading:false可以执行请求即可
      this.bs.on("scroll", async pos => {
        let top = this.bs.scrollerHeight + pos.y - this.bs.wrapper.offsetHeight;
        if (top < 90 && !this.loadEnd) {
          // 滚动事件通知父组件
          this.$emit("loadNext");
        }
      });
    }, 100);
  },
  methods: {
    // 点击每一项的事件
    itemClick(item) {
      this.$emit("itemClick", item);
    },
    // 父组件调用refresh
    pRefresh() {
      if (this.bs) {
        console.log("this.bs.content", this.bs, this.bs.content);
        this.bs.refresh();
      }
    },
    destroy() {
      if (this.bs) {
        this.bs.destroy();
      }
    }
  },
  created() {}
};
</script>
<style lang="less" scope>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  top: 0;
  left: 0;
  .content {
    .emptyDataImg {
      padding-top: 20px;
      text-align: center;
      p {
        margin: 0;
        color: #969799;
        font-size: 12px;
      }
    }
    .laodEndText {
      color: #969799;
      font-size: 14px;
      text-align: center;
      padding: 15px 0;
      margin: 0;
    }
  }
}
</style>
